import { render } from "./Registrations.vue?vue&type=template&id=4d703a8e"
import script from "./Registrations.vue?vue&type=script&lang=js"
export * from "./Registrations.vue?vue&type=script&lang=js"
script.render = render

export default script